export default function MessagingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M7.63419 14.4996C8.09998 15.8156 8.96221 16.9549 10.1022 17.7608C11.2422 18.5666 12.6039 18.9993 14 18.9993H20.1875C20.3367 18.9993 20.4798 18.94 20.5852 18.8345C20.6907 18.729 20.75 18.586 20.75 18.4368V12.2493C20.75 10.5229 20.0885 8.86213 18.9016 7.60848C17.7147 6.35483 16.0926 5.60357 14.3688 5.50917M8.00001 14.4993H1.8125C1.66332 14.4993 1.52024 14.44 1.41475 14.3345C1.30926 14.229 1.25 14.086 1.25 13.9368V7.74925C1.25 5.95904 1.96116 4.24216 3.22703 2.97629C4.49289 1.71042 6.20978 0.999267 7.99999 0.999268C9.7902 0.999268 11.5071 1.71043 12.773 2.9763C14.0388 4.24217 14.75 5.95906 14.75 7.74927C14.75 9.53948 14.0388 11.2564 12.773 12.5222C11.5071 13.7881 9.79022 14.4993 8.00001 14.4993Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
